import React from 'react';
import { Clock, Car, PlayCircle, Award } from 'lucide-react';
const benefits = [{
  icon: Clock,
  title: '24/7 Online Access',
  description: 'Study on your schedule, day or night.'
}, {
  icon: Car,
  title: 'No Driving Required',
  description: 'Complete courses from the comfort of home.'
}, {
  icon: PlayCircle,
  title: 'Start & Stop Anytime',
  description: 'Your progress is automatically saved.'
}, {
  icon: Award,
  title: 'Instant Certificates',
  description: 'Download your certificate immediately upon completion.'
}];
export function ValuePropositions() {
  return <section className="bg-brand-purple-700 py-12 text-white" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <h2 className="sr-only" data-id="element-191">Why Choose Desert Sage Seminars</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-192">
          {benefits.map((benefit, index) => <div key={index} className="flex flex-col items-center text-center p-4" data-id="element-193">
              <div className="mb-4 p-3 bg-brand-purple-600 rounded-full text-brand-orange-400" data-id="element-194">
                <benefit.icon className="w-8 h-8" data-id="element-195" />
              </div>
              <h3 className="text-lg font-bold mb-2" data-id="element-196">{benefit.title}</h3>
              <p className="text-brand-purple-100 text-sm" data-id="element-197">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}